/**
 * @generated SignedSource<<562b8bb8b61799df68643867ec2bb28a>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useIsSellerOnline_viewer$data = {
  readonly presenceFeatureFlag: boolean | null;
  readonly " $fragmentType": "useIsSellerOnline_viewer";
};
export type useIsSellerOnline_viewer$key = {
  readonly " $data"?: useIsSellerOnline_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"useIsSellerOnline_viewer">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "useIsSellerOnline_viewer"
};

(node as any).hash = "292452efa50393fe4f51a89b2e5cc037";

export default node;
